export const columns = [
  {
    title: "材料名称",
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "收货单签收数量",
    dataIndex: "currentSignCount",
    key: "currentSignCount",
  },
];
